import { useNavigate } from "react-router-dom";
import "./TopOfferBar.css";

export default function TopOfferBar() {

    const navigate = useNavigate();

    const offers = [
        "🌿 Premium Mithila Makhana",
        "🌱 100% Natural • No Artificial Preservatives",
        "🏆 Handpicked & Quality Assured",
        "💪 Rich in Protein • Gluten Free • Healthy Snacking"
    ];

    return (

        <div className="top-offer-bar">

            <div className="offer-list">

                {offers.map((offer, index) => (

                    <div
                        key={index}
                        className="offer-item"
                    >
                        {offer}
                    </div>

                ))}

            </div>

            <button
                className="contact-btn"
                onClick={() => navigate("/contact-us")}
            >
                📞 Contact Us
            </button>

        </div>

    );
}